import { render } from "./CaiGouShenPiDetail.vue?vue&type=template&id=f6ed35de"
import script from "./CaiGouShenPiDetail.vue?vue&type=script&lang=js"
export * from "./CaiGouShenPiDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__